module.exports = __webpack_public_path__ + "static/media/emotion_1.681e5e76.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/bot_gif/emotion_1.gif
// module id = 1283
// module chunks = 0